import { CrudBuilderConfig } from '../../components/crudbuilder/models/crud-builder-config';
import { FieldConfig } from '../../components/crudbuilder/models/field-config';
import { createRetirement, Retirement } from '../../state/retirements';
import ListFormatter from '@core/helpers/list-formatter';
import Formatter from '@core/helpers/formatter';

export class RetirementsCrudBuilderConfigClass extends CrudBuilderConfig {
  singular   = 'Retirement';
  plural     = 'Retirements';
  modelAlias = 'retirement';
  path       = 'retirements';
  fields     = [
    new FieldConfig('person_id', 'person', 'Person'),
    new FieldConfig('current', 'money'),
    new FieldConfig('to_achieve', 'money', 'Goal'),
    new FieldConfig('from_age', 'number'),
    new FieldConfig('to_age', 'number'),
    new FieldConfig('divorce_settlement', 'text'),
    new FieldConfig('retirement_configuration_id', 'retirement_type', 'Retirement'),
    new FieldConfig('financial_company_id', 'financial_companies', 'Financial Company'),
  ];

  readFields = [
    new FieldConfig('person_id', 'person', 'Person'),
    new FieldConfig('current', 'money'),
    new FieldConfig('to_achieve', 'money', 'Goal'),
    new FieldConfig('from_age', 'number'),
    new FieldConfig('to_age', 'number'),
    new FieldConfig('divorce_settlement', 'text'),
    new FieldConfig('retirement', 'relation_config', 'Type'),
  ];

  listView(model: Retirement) {
    const view = new ListFormatter()
      .fHead('Divorce Settlement', model.divorce_settlement)
      .fSub('Type', model.retirement.name)
      .fSub('Current', Formatter.formatMoney(model.current))
      .fSub('Goal', Formatter.formatMoney(model.to_achieve))
    ;
    return view.toString();
  }

  getModel() {
    return createRetirement({});
  }

  getReadTitle(model: Retirement) {
    return '';
  }

  editPreprocess(model: Retirement) {
    const nm                       = {...model};
    nm.retirement_configuration_id = model.retirement.id;
    return nm;
  }

  runBeforeSavingOnAddView(model: Retirement, states) {
    return model;
  }
}

export const RetirementsCrudBuilderConfig = new RetirementsCrudBuilderConfigClass();
